import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Pickup',
        [ORDER_METHODS.DELIVERY]: 'Delivery',
        [ORDER_METHODS.ON_SITE]: 'Table ordering',
      },
    },
    delivery_info: {
      title: 'Delivery details',
      on_arrival: 'On arrival:',
    },
    customer_info: {
      title: 'Contact',
    },
    payment: {
      title: 'Payment',
    },
    request_invoice: {
      title: 'Request invoice',
      form: {
        is_receipt_required: {
          label: 'Request invoice via email',
        },
      },
    },
    location: {
      title: 'Store address',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Delivery address',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Your table',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Pickup address',
      },
    },
    method: {
      title: 'Method',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Delivery',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Table ordering',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Pickup',
      },
    },
    time: {
      title: 'Time',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Standard {{time}} min, Today',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Schedule for later',
        },
      },
    },
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Ring door bell',
        [DropoffAction.Sms]: 'Contact me via SMS upon arrival',
      },
    },
    doorbell_name: {
      placeholder: 'Door bell name (optional)',
    },
    company_name: {
      placeholder: 'Company name (optional)',
    },
    customer_note: {
      placeholder: 'Any note for the restaurant?',
    },
  },
  buttons: {
    change: 'Change',
    edit: 'Edit',
    done: 'Done',
    add_delivery_note: '+ Add delivery details',
    add_order_note: '+ Add order note',
  },
  summary: {
    doorbell: 'Doorbell',
    company: 'Company',
    note: 'Order note',
  },
};
